// extracted by mini-css-extract-plugin
module.exports = {"highlightedElement":"ConfirmModal_highlightedElement__2PJCU"};